const urlName = '/notify/v1'
export default API => ({
  getList({params, data}) {
    return API({ // 详情列表
      url: `${urlName}/user/msg/list`,
      params,
      data,
      method: 'post'
    });
  },
  getDetail(params) {
    return API({ // 详情列表
      url: `${urlName}/user/msg/getDetail`,
      params,
      method: 'get'
    });
  },
  existUnread() {
    return API({ // 详情列表
      url: `${urlName}/user/msg/existUnread`,
      method: 'get'
    });
  },
  delete(params) {
    return API({ // 详情列表
      url: `${urlName}/user/msg/delete`,
      params,
      method: 'get'
    });
  },
  readAll() {
    return API({ // 详情列表
      url: `${urlName}/user/msg/readAll`,
      method: 'get'
    });
  },
  readOne(params) {
    return API({ 
      url: `${urlName}/user/msg/readOne`,
      params,
      method: 'get'
    });
  },
})